import React from 'react';
import { defaultTheme } from './../../styles/theme/default';
import { IIcon } from './../../@types/icons';

export function Note ({ strokeColor, fillColor }: IIcon) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill={fillColor ? defaultTheme.colors[fillColor] || fillColor : 'none'}
      viewBox="0 0 16 16"
    >
      <path
        stroke={
          strokeColor
            ? defaultTheme.colors[strokeColor] || strokeColor
            : defaultTheme.colors.dimGray
        }
        strokeLinecap="round"
        d="M12.5 4.5v-2a1 1 0 00-1-1h-2M6 15.5H1.5a1 1 0 01-1-1v-12a1 1 0 011-1h2"
      />
      <path
        stroke={
          strokeColor
            ? defaultTheme.colors[strokeColor] || strokeColor
            : defaultTheme.colors.dimGray
        }
        d="M3.5 1.5a1 1 0 011-1h4a1 1 0 011 1V2a1 1 0 01-1 1h-4a1 1 0 01-1-1v-.5zM15.5 11a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zM8 14l6-6"
      />
    </svg>
  );
}
